<template>
  <div id="app" class="wrapper" :class="[backgroundClass, { 'wrapper--cart-is-docked': isCartDocked }]">
    <oie-static-header-actions></oie-static-header-actions>
    <oie-static-header></oie-static-header>

    <div class="information-layout__breadcrumb-container">
      <oie-breadcrumb css-classes="information-layout__breadcrumb" :items="[{id: 'start', url: '/start', name: 'Start'}, {id: 'register', url: '/registrering', name: 'registrering'}]"></oie-breadcrumb>
    </div>

    <div class="information-layout">
      <oie-static-information-navigation css-classes="information-layout__sidebar"></oie-static-information-navigation>

      <main class="information-layout__main">
        <slot></slot>

        <oie-static-social-island></oie-static-social-island>
      </main>
    </div>

    <oie-static-footer></oie-static-footer>

    <oie-overlay></oie-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('ui', ['isCartDocked']),
    backgroundClass() {
      return this.$route.meta.backgroundColor !== undefined ? `wrapper--${this.$route.meta.backgroundColor}` : undefined
    }
  }
}
</script>
